export const slidesIframe: Ref<any> = ref<any>(null);

// const isDev = process.env.NODE_ENV === "development";

// export const iframeSrc = isDev
//   ? "http://local.pcdashi.cn"
//   : "/iframe/ppt/index.html";
export const iframeSrc = "/iframe/ppt/index.html";

export const iframePostMessage = (type: string, payload?: any) => {
  const iframe = document.getElementById("slidesIframe") as HTMLIFrameElement;

  iframe.contentWindow!.postMessage(
    {
      type,
      payload,
    },
    "*"
  );
};
